/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */

'use strict';

import { EntityBase } from './entitybase';
import * as tools from '../utils/tools';

export class Record extends EntityBase {
    /**
     * Create a Record object.
     * @param {number|null} rtID - The ID of the record type this record is created from.
     * @param {number|null} rID - The record ID; if not supplied (or negative), a temporary ID will be assigned.
     * @param {string} [code = ""] - The record code for this record.
     * @class
     * @classdesc Record Object
     */
    constructor (rtID, rID, code) {
        super();

        /**
         * The ID of the record type this record is created from.
         * @type {number}
         */
        this.RecordTypeID = rtID;

        /**
         * The record ID; if not supplied (or negative), a temporary ID will be assigned.
         * @type {number}
         */
        this.RecordID = rID > 0 ? rID : tools.tempID();

        /**
         * The record code for this record.
         * @type {string}
         */
        this.Code = code ? code : '';

        /**
         * The status for the record.
         * @type {ValueStatus|null}
         */
        this.Status = null;
    }
}

export function create (rtID, rID, code) {
    return new Record(rtID, rID, code);
}